import React from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from '../../utils/animations';
import { useLanguage } from '../../contexts/LanguageContext';
import { useViewpoint, VIEWPOINTS } from '../../contexts/ViewpointContext';

const AboutUs = () => {
  const { t } = useLanguage();
  const { currentViewpoint } = useViewpoint();
  
  // ONLY change title size for mobile, keep all other styles exactly the same
  const getTitleClasses = (isGradient = false) => {
    const baseClasses = `text-6xl font-bold leading-tight tracking-tight ${
      isGradient 
        ? 'bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 text-transparent bg-clip-text' 
        : 'text-white'
    }`;
    
    // ONLY override font size if we're on mobile
    if (currentViewpoint === VIEWPOINTS.MOBILE) {
      return `text-[32px] font-bold leading-tight tracking-tight ${
        isGradient 
          ? 'bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 text-transparent bg-clip-text' 
          : 'text-white'
      }`;
    }
    
    return baseClasses;
  };
  
  return (
    <section 
      id="about-us"
      className="relative py-32 overflow-hidden bg-cover bg-center bg-fixed" 
      style={{ 
        backgroundImage: 'url(https://cdn.nexastaff.ai/back2.jpg)',
        '--about-bg-overlay-opacity': '0.85'
      }}
    >
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900/95 via-gray-900/90 to-gray-900/95"></div>
      
      <div className="container mx-auto px-4 relative">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeIn}
          className="max-w-[900px] mx-auto"
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="space-y-12 text-center"
          >
            <div className="space-y-4">
              <h2 className={getTitleClasses()}>
                {t('about.title')}
              </h2>
              <h2 className={getTitleClasses(true)}>
                {t('about.subtitle')}
              </h2>
            </div>
            
            <div className="space-y-8 text-gray-300">
              <p className="text-xl leading-relaxed">
                {t('about.description1')}
              </p>

              <p className="text-xl leading-relaxed">
                {t('about.description2')}
              </p>

              <div className="pt-8">
                <p className="text-3xl font-semibold text-white">
                  {t('about.closing1')}
                </p>
                <p className="text-3xl font-semibold bg-gradient-to-r from-blue-400 to-purple-400 text-transparent bg-clip-text">
                  {t('about.closing2')}
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutUs; 